import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { type PropsWithChildren, useEffect, useState } from 'react';
import type { Link } from 'types/menu';

export type SocialMediaType = 'Facebook' | 'Twitter' | 'LinkedIn' | 'MailTo';

interface SocialShareButtonProps extends PropsWithChildren, PropsWithClassProps<'link'> {
  link: Link;
  type: SocialMediaType;
}

export const SocialShareButton = ({ children, classProps, link, type }: SocialShareButtonProps) => {
  let baseUrl: string;

  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  if (type === 'Facebook') {
    baseUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  } else if (type === 'Twitter') {
    baseUrl = `https://twitter.com/intent/tweet?text=${url}`;
  } else if (type === 'LinkedIn') {
    baseUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
  } else if (type === 'MailTo') {
    baseUrl = `mailto:?subject=${link.title}&body=${url}`;
  } else {
    baseUrl = '';
  }

  return (
    <a href={baseUrl} target="_blank" rel="noreferrer" className={classProps?.link} aria-label={type}>
      {children}
    </a>
  );
};
